import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from "react-native";
import Tooltip from "./Tooltip";
import { colors, tooltipDragSelectText } from "./useStyles";
export default function TooltipDragSelect({ tooltip = {}, transform, }) {
    return (_jsx(Tooltip, Object.assign({ tooltip: tooltip, styleArrow: { borderTopColor: colors.green600 }, styleContentBox: { backgroundColor: colors.green600 }, transform: transform }, { children: _jsx(Text, Object.assign({ style: tooltipDragSelectText }, { children: "Jel\u00F6lje ki a vizsg\u00E1lni k\u00EDv\u00E1nt intervallumot!" })) })));
}
